export default {
  reset_user: null, // unset user
  open: null, // will be populated with a function
}